import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/categories';

export default function TestimonialsSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 rounded-full px-4 py-1.5">
            {t('testimonials.tag')}
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-none">
            {t('testimonials.title1')}
            <br />
            {t('testimonials.title2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.name}
                  </p>
                  <p className="text-xs text-foreground-400">
                    {item.handle}
                  </p>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex gap-0.5 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-primary-500"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}